import firebase from "firebase/compat/app";
import "firebase/compat/database";

const projectIdByCharity = new Map<string, string>();

export async function resolveDonorsFirebaseProjectId(
  charityId: string
): Promise<string | undefined> {
  const mainProjectId = (firebase.app().options as { projectId?: string })
    .projectId;
  if (!mainProjectId || !charityId) {
    return undefined;
  }

  const cacheKey = `${charityId}:${mainProjectId}`;
  const cached = projectIdByCharity.get(cacheKey);
  if (cached) {
    return cached;
  }

  try {
    const snapshot = await firebase
      .database()
      .ref(`${charityId}/config/firebase/projectId`)
      .once("value");
    const childProjectId = snapshot.val();
    const projectId =
      typeof childProjectId === "string" && childProjectId.length > 0
        ? childProjectId
        : mainProjectId;
    projectIdByCharity.set(cacheKey, projectId);
    return projectId;
  } catch {
    return mainProjectId;
  }
}
